import React, { useEffect, useState } from "react";
import { useLazyGetCmsQuery } from "../../services/cms";

const PrivacyPolicyUrl = () => {
  const [getCms] = useLazyGetCmsQuery();

  const [privacyPolicy, setPrivacyPolicy] = useState<string>("");
  const getCmsData = async () => {
    try {
      const response = await getCms({}).unwrap();
      if (response.statusCode === 200) {
        setPrivacyPolicy(response?.data?.privacyPolicy);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <div className="delete-policy">
      <p dangerouslySetInnerHTML={{ __html: privacyPolicy || "" }} />
    </div>
  );
};

export default PrivacyPolicyUrl;
